import React from 'react';
import QuizResultExtraCard from './QuizResultExtraCard.jsx';
import PropTypes from 'prop-types';

class QuizResultExtra extends React.Component {
  render() {
    const { extras, location, fptiHelper } = this.props;
    return (
      <div>
        {extras.map(extraCardKey => {
          return (
            <QuizResultExtraCard
              key={extraCardKey}
              extraCardName={extraCardKey}
              location={location}
              fptiHelper={fptiHelper}
            />
          );
        })}
      </div>
    );
  }
}

QuizResultExtra.propTypes = {
  extras: PropTypes.array,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};

export default QuizResultExtra;
